/*
 *ngFor="let c of oneDimArray | sortBy:'asc'"
 *ngFor="let c of arrayOfObjects | sortBy:'asc':'propertyName'"
*/
import { Pipe, PipeTransform } from "@angular/core";
import { orderBy } from "lodash";

@Pipe({ name: "sortBy" })
export class SortByPipe implements PipeTransform {

  public transform(value: any[], order = "", column: string = ""): any[] {
    if (!value || order === "" || !order) { return value; }
    if (!column || column === "") { return orderBy(value); }
    if (value.length <= 1) { return value; }
    return orderBy(value, [column], [order]);
  }
}
